package com.evoapps.evoshift.ui.checklists

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowLeft
import androidx.compose.material.icons.automirrored.filled.KeyboardArrowRight
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Checklist
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExtendedFloatingActionButton
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.ChecklistItem
import com.evoapps.evoshift.domain.model.ChecklistKind
import com.evoapps.evoshift.domain.model.ChecklistProblem
import com.evoapps.evoshift.domain.model.ChecklistTemplate
import com.evoapps.evoshift.domain.model.Checklists
import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.domain.usecase.checklist.ShiftChecklists
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.CentredLazyColumn
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.dayAndDate
import com.evoapps.evoshift.ui.util.dayShort
import com.evoapps.evoshift.ui.util.toUiText
import com.evoapps.evoshift.viewmodels.ChecklistsTab
import com.evoapps.evoshift.viewmodels.ChecklistsUiState
import com.evoapps.evoshift.viewmodels.ChecklistsViewModel
import com.evoapps.evoshift.viewmodels.Gate
import com.evoapps.evoshift.viewmodels.shows
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoRadioGroup
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.checklist_add_item
import evoshift.composeapp.generated.resources.checklist_attach_days
import evoshift.composeapp.generated.resources.checklist_attach_days_hint
import evoshift.composeapp.generated.resources.checklist_attach_shifts
import evoshift.composeapp.generated.resources.checklist_completed_at
import evoshift.composeapp.generated.resources.checklist_delete
import evoshift.composeapp.generated.resources.checklist_delete_confirm
import evoshift.composeapp.generated.resources.checklist_edit
import evoshift.composeapp.generated.resources.checklist_item_label
import evoshift.composeapp.generated.resources.checklist_item_needs_note
import evoshift.composeapp.generated.resources.checklist_items
import evoshift.composeapp.generated.resources.checklist_items_count
import evoshift.composeapp.generated.resources.checklist_kind
import evoshift.composeapp.generated.resources.checklist_name
import evoshift.composeapp.generated.resources.checklist_on_days
import evoshift.composeapp.generated.resources.checklist_on_shifts
import evoshift.composeapp.generated.resources.checklist_remove_item
import evoshift.composeapp.generated.resources.checklists_day_empty
import evoshift.composeapp.generated.resources.checklists_new
import evoshift.composeapp.generated.resources.checklists_next_day
import evoshift.composeapp.generated.resources.checklists_previous_day
import evoshift.composeapp.generated.resources.checklists_tab_day
import evoshift.composeapp.generated.resources.checklists_tab_templates
import evoshift.composeapp.generated.resources.checklists_templates_empty
import evoshift.composeapp.generated.resources.checklists_title
import evoshift.composeapp.generated.resources.checklists_today
import evoshift.composeapp.generated.resources.save
import kotlinx.datetime.DayOfWeek
import org.jetbrains.compose.resources.stringResource

/** Test tags of the screen's fixed parts. */
object ChecklistsTags {
    const val NEW = "checklists_new"
    const val PREVIOUS_DAY = "checklists_previous_day"
    const val NEXT_DAY = "checklists_next_day"
    const val DATE = "checklists_date"
    const val ADD_ITEM = "checklist_add_item"
    fun itemField(index: Int) = "checklist_item_field_$index"
    fun itemNeedsNote(index: Int) = "checklist_item_note_$index"
    fun removeItem(index: Int) = "checklist_item_remove_$index"
    fun weekday(day: Int) = "checklist_weekday_$day"
    fun shiftTemplate(id: String) = "checklist_shift_template_$id"
    const val NAME = "checklist_name"
}

/**
 * SH-121, the managers' Checklists (from More, a reminder notification): each day's shifts with
 * their checklists, who ticked what and their notes (today, or back day by day: the history), and
 * the workplace's templates: opening, closing or other checklists, put on shifts planned like a
 * shift template or on days of the week.
 */
@Composable
fun ChecklistsScreen(viewModel: ChecklistsViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbar = remember { SnackbarHostState() }
    val text = (state.error ?: state.message)?.asString()
    LaunchedEffect(text) {
        if (text != null) {
            snackbar.showSnackbar(text)
            viewModel.messageShown()
        }
    }

    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbar) },
        topBar = { EvoTopBar(title = stringResource(Res.string.checklists_title), onBack = onNavigateBack, showWorkplace = true) },
        floatingActionButton = {
            if (state.tab == ChecklistsTab.TEMPLATES && state.canEdit) {
                ExtendedFloatingActionButton(
                    onClick = viewModel::startNew,
                    containerColor = DeepNavy,
                    contentColor = Color.White,
                    icon = { Icon(Icons.Default.Add, contentDescription = null) },
                    text = { Text(stringResource(Res.string.checklists_new)) },
                    modifier = Modifier.handCursor().testTag(ChecklistsTags.NEW)
                )
            }
        }
    ) { padding ->
        // SH-130: the lists fill the screen (the wheel scrolls them over the sides); their content
        // and the headers above them are a centred column.
        Box(Modifier.padding(padding).fillMaxSize()) {
            if (state.isLoading) {
                CircularProgressIndicator(Modifier.align(Alignment.Center), color = DeepNavy)
                return@Box
            }
            Column(Modifier.fillMaxSize()) {
                Tabs(state.tab, viewModel::selectTab)
                when (state.tab) {
                    ChecklistsTab.DAY -> DayPane(state, viewModel)
                    ChecklistsTab.TEMPLATES -> TemplatesPane(state, viewModel)
                }
            }
        }
    }

    state.editing?.let { editing ->
        ChecklistTemplateDialog(
            template = editing,
            shiftTemplates = state.shiftTemplates,
            problems = state.editorProblems,
            saving = state.isSaving,
            onChange = viewModel::updateEditing,
            onSave = viewModel::saveEditing,
            onDelete = if (editing.id.isNotBlank() && state.canEdit) { { viewModel.delete(editing) } } else null,
            onDismiss = viewModel::cancelEditing
        )
    }
}

@Composable
private fun Tabs(selected: ChecklistsTab, onSelect: (ChecklistsTab) -> Unit) {
    val colors = FilterChipDefaults.filterChipColors(
        selectedContainerColor = DeepNavy,
        selectedLabelColor = Color.White,
        labelColor = DeepNavy
    )
    Row(Modifier.fillMaxWidth().contentWidth(ContentMaxWidth).padding(horizontal = 16.dp, vertical = 8.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        ChecklistsTab.entries.forEach { tab ->
            FilterChip(
                selected = tab == selected,
                onClick = { onSelect(tab) },
                label = {
                    Text(stringResource(if (tab == ChecklistsTab.DAY) Res.string.checklists_tab_day else Res.string.checklists_tab_templates))
                },
                colors = colors,
                modifier = Modifier.handCursor()
            )
        }
    }
}

@Composable
private fun DayPane(state: ChecklistsUiState, viewModel: ChecklistsViewModel) {
    Column(Modifier.fillMaxSize()) {
        Row(Modifier.fillMaxWidth().contentWidth(ContentMaxWidth).padding(horizontal = 8.dp), verticalAlignment = Alignment.CenterVertically) {
            IconButtonWithTooltip(onClick = viewModel::previousDay, modifier = Modifier.handCursor().testTag(ChecklistsTags.PREVIOUS_DAY), tooltip = stringResource(Res.string.checklists_previous_day)) {
                Icon(Icons.AutoMirrored.Filled.KeyboardArrowLeft, contentDescription = stringResource(Res.string.checklists_previous_day), tint = DeepNavy)
            }
            Text(
                dayAndDate(state.date),
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = DeepNavy,
                modifier = Modifier.weight(1f).testTag(ChecklistsTags.DATE)
            )
            if (state.date != state.today) {
                TextButton(onClick = viewModel::goToToday, modifier = Modifier.handCursor()) {
                    Text(stringResource(Res.string.checklists_today), color = DeepNavy, fontWeight = FontWeight.Bold)
                }
                IconButtonWithTooltip(onClick = viewModel::nextDay, modifier = Modifier.handCursor().testTag(ChecklistsTags.NEXT_DAY), tooltip = stringResource(Res.string.checklists_next_day)) {
                    Icon(Icons.AutoMirrored.Filled.KeyboardArrowRight, contentDescription = stringResource(Res.string.checklists_next_day), tint = DeepNavy)
                }
            }
        }
        if (state.day.isEmpty()) {
            Text(
                stringResource(Res.string.checklists_day_empty),
                style = MaterialTheme.typography.bodyMedium,
                color = DeepNavy.copy(alpha = 0.7f),
                modifier = Modifier.fillMaxWidth().contentWidth(ContentMaxWidth).padding(16.dp)
            )
            return
        }
        CentredLazyColumn(
            maxWidth = ContentMaxWidth,
            contentPadding = androidx.compose.foundation.layout.PaddingValues(16.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            items(state.day, key = { it.shift.id }) { row -> Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) { DayShiftCard(row, state.names) } }
        }
    }
}

@Composable
private fun DayShiftCard(row: ShiftChecklists, names: Map<String, String>) {
    RegularCard(Modifier.fillMaxWidth().testTag(checklistDayTag(row.shift.id))) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            // SH-235: someone assigned is never a blank (the label when their name is missing).
            val name = if (row.shift.userId != null) com.evoapps.evoshift.ui.util.personName(row.shift.userId?.let { names[it] } ?: row.shift.userDisplayName)
                else row.shift.userDisplayName.orEmpty()
            Text(
                "$name · ${Checklists.hourOf(row.shift.plannedTime.start)}–${Checklists.hourOf(row.shift.plannedTime.end)}",
                style = MaterialTheme.typography.titleSmall,
                fontWeight = FontWeight.Bold,
                color = DeepNavy.copy(alpha = 0.8f)
            )
            row.checklists.forEachIndexed { index, checklist ->
                if (index > 0) HorizontalDivider(color = DeepNavy.copy(alpha = 0.08f))
                ChecklistHeader(checklist)
                checklist.completedAt?.let { at ->
                    checklistLocalTime(at)?.let {
                        Text(stringResource(Res.string.checklist_completed_at, it), style = MaterialTheme.typography.labelMedium, color = ChecklistDoneColor)
                    }
                }
                ChecklistSkippedLine(checklist)
                checklist.items.forEach { item -> ChecklistItemRow(checklist, item, onToggle = null) }
            }
        }
    }
}

@Composable
private fun TemplatesPane(state: ChecklistsUiState, viewModel: ChecklistsViewModel) {
    if (state.templates.isEmpty()) {
        Text(
            stringResource(Res.string.checklists_templates_empty),
            style = MaterialTheme.typography.bodyMedium,
            color = DeepNavy.copy(alpha = 0.7f),
            modifier = Modifier.fillMaxWidth().contentWidth(ContentMaxWidth).padding(16.dp)
        )
        return
    }
    CentredLazyColumn(
        maxWidth = ContentMaxWidth,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(start = 16.dp, end = 16.dp, top = 8.dp, bottom = 96.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        items(state.templates, key = { it.id }) { template ->
            Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                TemplateCard(
                    template = template,
                    shiftTemplates = state.shiftTemplates,
                    onClick = if (state.capabilities.shows(Gate.CHECKLIST_EDITING)) { { viewModel.edit(template) } } else null
                )
            }
        }
    }
}

@Composable
private fun TemplateCard(template: ChecklistTemplate, shiftTemplates: List<ShiftTemplate>, onClick: (() -> Unit)?) {
    RegularCard(Modifier.fillMaxWidth().handCursor().testTag(checklistTemplateTag(template.id)), onClick = onClick) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Checklist, contentDescription = null, tint = DarkGold, modifier = Modifier.size(20.dp))
                Spacer(Modifier.size(8.dp))
                Text(template.name, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = DeepNavy, modifier = Modifier.weight(1f))
                Text(stringResource(template.kind.label), style = MaterialTheme.typography.labelLarge, color = DeepNavy.copy(alpha = 0.7f))
            }
            Text(stringResource(Res.string.checklist_items_count, template.items.size), style = MaterialTheme.typography.bodyMedium, color = DeepNavy.copy(alpha = 0.8f))
            val shifts = template.shiftTemplateIds.mapNotNull { id -> shiftTemplates.firstOrNull { it.id == id } }
            if (shifts.isNotEmpty()) {
                Text(
                    stringResource(Res.string.checklist_on_shifts, shifts.joinToString { shiftTemplateLabel(it) }),
                    style = MaterialTheme.typography.bodySmall,
                    color = DeepNavy.copy(alpha = 0.7f)
                )
            }
            if (template.weekdays.isNotEmpty()) {
                val days = template.weekdays.map { dayShort(DayOfWeek(it)) }
                Text(stringResource(Res.string.checklist_on_days, days.joinToString()), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
            }
        }
    }
}

private fun shiftTemplateLabel(t: ShiftTemplate) = "${t.name} ${Checklists.hourOf(t.startTime)}–${Checklists.hourOf(t.endTime)}"

/** The template editor: name, kind, tasks (each may need a note), the shifts and days it goes on. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun ChecklistTemplateDialog(
    template: ChecklistTemplate,
    shiftTemplates: List<ShiftTemplate>,
    problems: Set<ChecklistProblem>,
    saving: Boolean,
    onChange: (ChecklistTemplate) -> Unit,
    onSave: () -> Unit,
    onDelete: (() -> Unit)?,
    onDismiss: () -> Unit
) {
    var confirmDelete by remember { mutableStateOf(false) }
    EvoDialog(
        title = stringResource(if (template.id.isBlank()) Res.string.checklists_new else Res.string.checklist_edit),
        icon = Icons.Default.Checklist,
        onDismiss = onDismiss,
        dismissible = !saving,
        confirm = DialogAction(stringResource(Res.string.save), onSave, loading = saving),
        neutral = onDelete?.let { DialogAction(stringResource(Res.string.checklist_delete), { confirmDelete = true }, destructive = true, icon = Icons.Default.Delete) }
    ) {
        problems.sortedBy { it.ordinal }.forEach { problem ->
            Text(problem.toUiText().asString(), color = Color(0xFFFF8A80), fontWeight = FontWeight.Bold)
        }
        EvoTextField(
            value = template.name,
            onValueChange = { onChange(template.copy(name = it.take(Checklists.NAME_MAX_LENGTH))) },
            label = stringResource(Res.string.checklist_name),
            modifier = Modifier.testTag(ChecklistsTags.NAME)
        )
        DialogSection(stringResource(Res.string.checklist_kind)) {
            EvoRadioGroup(
                options = ChecklistKind.entries,
                selected = template.kind,
                onSelect = { onChange(template.copy(kind = it)) },
                optionLabel = { stringResource(it.label) },
                horizontal = true
            )
        }
        DialogSection(stringResource(Res.string.checklist_items)) {
            template.items.forEachIndexed { index, item ->
                Row(verticalAlignment = Alignment.CenterVertically) {
                    EvoTextField(
                        value = item.text,
                        onValueChange = { text -> onChange(template.withItem(index, item.copy(text = text.take(Checklists.ITEM_MAX_LENGTH)))) },
                        label = stringResource(Res.string.checklist_item_label, index + 1),
                        modifier = Modifier.weight(1f).testTag(ChecklistsTags.itemField(index))
                    )
                    IconButtonWithTooltip(
                        onClick = { onChange(template.copy(items = template.items.filterIndexed { i, _ -> i != index })) },
                        modifier = Modifier.handCursor().testTag(ChecklistsTags.removeItem(index)),
                        tooltip = stringResource(Res.string.checklist_remove_item)
                    ) {
                        Icon(Icons.Default.Close, contentDescription = stringResource(Res.string.checklist_remove_item), tint = Color.White.copy(alpha = 0.7f))
                    }
                }
                EvoCheckboxRow(
                    checked = item.requiresNote,
                    onCheckedChange = { onChange(template.withItem(index, item.copy(requiresNote = it))) },
                    label = stringResource(Res.string.checklist_item_needs_note),
                    modifier = Modifier.testTag(ChecklistsTags.itemNeedsNote(index))
                )
            }
            if (template.items.size < Checklists.MAX_ITEMS) {
                TextButton(
                    onClick = { onChange(template.copy(items = template.items + ChecklistItem(id = "", text = ""))) },
                    modifier = Modifier.handCursor().testTag(ChecklistsTags.ADD_ITEM)
                ) {
                    Icon(Icons.Default.Add, contentDescription = null, tint = DarkGold)
                    Spacer(Modifier.size(6.dp))
                    Text(stringResource(Res.string.checklist_add_item), color = DarkGold, fontWeight = FontWeight.Bold)
                }
            }
        }
        if (shiftTemplates.isNotEmpty()) {
            DialogSection(stringResource(Res.string.checklist_attach_shifts)) {
                shiftTemplates.forEach { shift ->
                    EvoCheckboxRow(
                        checked = shift.id in template.shiftTemplateIds,
                        onCheckedChange = { on ->
                            onChange(template.copy(shiftTemplateIds = if (on) template.shiftTemplateIds + shift.id else template.shiftTemplateIds - shift.id))
                        },
                        label = shiftTemplateLabel(shift),
                        modifier = Modifier.testTag(ChecklistsTags.shiftTemplate(shift.id))
                    )
                }
            }
        }
        DialogSection(stringResource(Res.string.checklist_attach_days)) {
            Text(stringResource(Res.string.checklist_attach_days_hint), style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.7f))
            val colors = FilterChipDefaults.filterChipColors(
                selectedContainerColor = DarkGold,
                selectedLabelColor = DeepNavy,
                labelColor = Color.White
            )
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Checklists.WEEKDAYS.forEach { day ->
                    val on = day in template.weekdays
                    FilterChip(
                        selected = on,
                        onClick = { onChange(template.copy(weekdays = if (on) template.weekdays - day else (template.weekdays + day).sorted())) },
                        label = { Text(dayShort(DayOfWeek(day))) },
                        colors = colors,
                        modifier = Modifier.handCursor().testTag(ChecklistsTags.weekday(day))
                    )
                }
            }
        }
        Spacer(Modifier.height(4.dp))
    }
    if (confirmDelete && onDelete != null) {
        EvoConfirmDialog(
            title = stringResource(Res.string.checklist_delete),
            text = stringResource(Res.string.checklist_delete_confirm, template.name),
            confirmLabel = stringResource(Res.string.checklist_delete),
            onConfirm = { confirmDelete = false; onDelete() },
            onDismiss = { confirmDelete = false },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }
}

private fun ChecklistTemplate.withItem(index: Int, item: ChecklistItem) =
    copy(items = items.mapIndexed { i, old -> if (i == index) item else old })
